// Remaining Component: AndrologyLandingPage.js
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  Grid,
  CardContent,
  MenuItem,
  Menu,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { styled } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import AndrologyReportCard from './AndrologyReportCard';
import UIModal from '../../../../components/UIElements/UIModal';
import { setAndrologyData } from '../../../../actions/andrologyAction';
import { initialState } from '../../../../reducers/andrologyReducer';
import AndrologyReport from './AndrologyReport';
import FreezingInventory from './freezingInventory';
import PregnancyDetails from './pregnancyDetails';

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  borderRadius: '8px',
}));

const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3),
  border: '1px solid #ddd',
  borderRadius: '8px',
}));

export default function AndrologyLandingPage({
  setSelectedProcess,
  selectedProcess,
}) {
  const dispatch = useDispatch();
  const selectedPatientData = useSelector(
    (state) => state.andrologyReducer.selectedPatientData,
  );
  const hsaData = useSelector((state) => state.andrologyReducer.hsa);
  const dfiData = useSelector((state) => state.andrologyReducer.dfi);
  const qsaData = useSelector((state) => state.andrologyReducer.qsa);
  const sfrData = useSelector((state) => state.andrologyReducer.sfr);
  const iuiData = useSelector((state) => state.andrologyReducer.iui);
  const isNewReport = useSelector(
    (state) => state.andrologyReducer.isNewReport,
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuWidth, setMenuWidth] = useState(null);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [isReportSelected, setIsReportSelected] = useState(false);
  // const [isNewReport, setIsNewReport] = useState(false);

  const [tempSelectedOption, setTempSelectedOption] = useState(null);
  const [isFreezingInventory, setIsFreezingInventory] = useState(false);
  const [
    selectedSfrIdForFreezingInventory,
    setSelectedSfrIdForFreezingInventory,
  ] = useState(null);
  const [isPregnancyDetails, setIsPregnancyDetails] = useState(false);
  const [
    selectedIuiIdForPregnancyDetails,
    setSelectedIuiIdForPregnancyDetails,
  ] = useState(null);
  const handleButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuWidth(event.currentTarget.offsetWidth);
  };

  const checkSfrReport = () => {
    if (selectedPatientData.patient['sfr'].length > 0) {
      for (let i = 0; i < selectedPatientData.patient['sfr'].length; i++) {
        const report = selectedPatientData.patient['sfr'][i];
        if (report.reportId) {
          return true;
        }
      }
    }
    return false;
  };

  const handleMenuClose = (option) => {
    if (option) {
      setOpenConfirmModal(true);
      setTempSelectedOption(option);
    }

    setAnchorEl(null);
  };

  const handleCancelStartReport = () => {
    setSelectedProcess(null);
    setOpenConfirmModal(false);
  };

  const andrologyFormsHandler = (selectedProcess) => {
    dispatch(setAndrologyData('isNewReport', true));
    if (tempSelectedOption) {
      setSelectedProcess(tempSelectedOption);
      dispatch(
        setAndrologyData(
          tempSelectedOption.toLowerCase(),
          initialState[tempSelectedOption.toLowerCase()],
        ),
      );
    }
    setOpenConfirmModal(false);
  };

  if (isFreezingInventory && selectedSfrIdForFreezingInventory) {
    return (
      <FreezingInventory
        setIsFreezingInventory={setIsFreezingInventory}
        selectedPatientData={selectedPatientData}
        selectedSfrIdForFreezingInventory={selectedSfrIdForFreezingInventory}
      />
    );
  }
  if (isPregnancyDetails && selectedIuiIdForPregnancyDetails) {
    return (
      <PregnancyDetails
        setIsPregnancyDetails={setIsPregnancyDetails}
        selectedPatientData={selectedPatientData}
        selectedIuiIdForPregnancyDetails={selectedIuiIdForPregnancyDetails}
      />
    );
  }

  const reportDataSelectionHandler = () => {
    let reportData = null;
    switch (selectedProcess) {
      case 'HSA':
        reportData = hsaData;
        break;
      case 'QSA':
        reportData = qsaData;
        break;
      case 'DFI':
        reportData = dfiData;
        break;
      case 'SFR':
        reportData = sfrData;
        break;
      case 'IUI':
        reportData = iuiData;
        break;
      default:
        reportData = null;
    }
    return reportData;
  };

  return (
    <div
      className="theme-blush"
      style={{ display: 'flex', flexDirection: 'column', gap: '36px' }}
    >
      {!isReportSelected && (
        <>
          <StyledCard>
            <CardContent>
              <StyledBox>
                <Box display="flex" flexDirection="row" flexWrap="wrap" gap={2}>
                  {/* Left-hand side: Address, Phone, MPID */}
                  <Box flex="1 1 100%" sm="1 1 66%">
                    <Typography variant="body1" gutterBottom>
                      {selectedPatientData.patient.partner.firstName}{' '}
                      {selectedPatientData.patient.partner.lastName}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      Phone: {selectedPatientData.patient.partner.phone}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      MPID: {selectedPatientData.patient.upid}
                    </Typography>
                  </Box>
                </Box>
                {/* Right-hand side: Start Process button with dropdown */}
                <Box
                  flex="1 1 100%"
                  sm="1 1 33%"
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-end"
                >
                  <Box>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleButtonClick}
                      endIcon={<ArrowDropDownIcon />}
                    >
                      {'Start Process'}
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={() => handleMenuClose(null)}
                      MenuListProps={{ style: { width: menuWidth } }}
                    >
                      <MenuItem onClick={() => handleMenuClose('HSA')}>
                        HSA
                      </MenuItem>
                      <MenuItem onClick={() => handleMenuClose('QSA')}>
                        QSA
                      </MenuItem>
                      <MenuItem onClick={() => handleMenuClose('DFI')}>
                        DFI
                      </MenuItem>
                      {!checkSfrReport() && (
                        <MenuItem onClick={() => handleMenuClose('SFR')}>
                          Semen Freezing
                        </MenuItem>
                      )}
                      <MenuItem onClick={() => handleMenuClose('IUI')}>
                        IUI Report
                      </MenuItem>
                    </Menu>
                  </Box>
                </Box>
              </StyledBox>
            </CardContent>
          </StyledCard>
        </>
      )}

      {!isReportSelected && selectedProcess && !openConfirmModal && (
        <AndrologyReportCard
          reportData={reportDataSelectionHandler()}
          selectedPatientData={selectedPatientData}
          activeForm={selectedProcess.toLowerCase()}
          isReportSelected={isReportSelected}
          setIsReportSelected={setIsReportSelected}
          setSelectedProcess={setSelectedProcess}
        />
      )}
      {!isReportSelected &&
        !isNewReport &&
        selectedPatientData.patient['hsa'].map((data, index) => {
          return (
            <AndrologyReportCard
              key={index}
              reportData={data}
              selectedPatientData={selectedPatientData}
              activeForm="hsa"
              setIsReportSelected={setIsReportSelected}
              setSelectedProcess={setSelectedProcess}
            />
          );
        })}
      {!isReportSelected &&
        !isNewReport &&
        selectedPatientData.patient['qsa'].map((data, index) => (
          <AndrologyReportCard
            key={index}
            reportData={data}
            selectedPatientData={selectedPatientData}
            activeForm="qsa"
            setIsReportSelected={setIsReportSelected}
            setSelectedProcess={setSelectedProcess}
          />
        ))}

      {!isReportSelected &&
        !isNewReport &&
        selectedPatientData.patient['dfi'].map((data, index) => (
          <AndrologyReportCard
            key={index}
            reportData={data}
            selectedPatientData={selectedPatientData}
            activeForm="dfi"
            setIsReportSelected={setIsReportSelected}
            setSelectedProcess={setSelectedProcess}
          />
        ))}

      {!isReportSelected &&
        !isNewReport &&
        selectedPatientData.patient['iui'].map((data, index) => {
          return (
            <AndrologyReportCard
              key={index}
              reportData={data}
              selectedPatientData={selectedPatientData}
              activeForm="iui"
              setIsReportSelected={setIsReportSelected}
              setSelectedProcess={setSelectedProcess}
              setIsPregnancyDetails={setIsPregnancyDetails}
              setSelectedIuiIdForPregnancyDetails={
                setSelectedIuiIdForPregnancyDetails
              }
            />
          );
        })}

      {!isReportSelected &&
        !isNewReport &&
        selectedPatientData.patient['sfr']
          .filter((report) => !report.parentId)
          .map((data, index) => {
            if (!data?.parentId) {
              return (
                <AndrologyReportCard
                  key={index}
                  reportData={data}
                  selectedPatientData={selectedPatientData}
                  activeForm="sfr"
                  setIsReportSelected={setIsReportSelected}
                  setSelectedProcess={setSelectedProcess}
                  setIsFreezingInventory={setIsFreezingInventory}
                  setSelectedSfrIdForFreezingInventory={
                    setSelectedSfrIdForFreezingInventory
                  }
                />
              );
            }
          })}

      <UIModal
        title="Please confirm?"
        body="Are you sure you want to start this report?"
        proceedText="Confirm"
        cancelText="Cancel"
        show={openConfirmModal}
        onClose={() => handleCancelStartReport()}
        onSave={() => andrologyFormsHandler(selectedProcess)}
      />
      {isReportSelected && (
        <AndrologyReport
          activeForm={selectedProcess.toLowerCase()}
          setIsReportSelected={setIsReportSelected}
        />
      )}
    </div>
  );
}
